/* tslint:disable */
/* eslint-disable */
/**
 * Onbaording Buffetti Api
 * Onbaording Buffetti Api Specification
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: gianluca.stefanelli@linksmt.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CheckboxFieldFromJSON, CheckboxFieldToJSON, } from './CheckboxField';
import { RadioboxFieldFromJSON, RadioboxFieldToJSON, } from './RadioboxField';
import { SedeOperativaFromJSON, SedeOperativaToJSON, } from './SedeOperativa';
import { StringFieldFromJSON, StringFieldToJSON, } from './StringField';
/**
 * Check if a given object implements the BusinessSection interface.
 */
export function instanceOfBusinessSection(value) {
    let isInstance = true;
    return isInstance;
}
export function BusinessSectionFromJSON(json) {
    return BusinessSectionFromJSONTyped(json, false);
}
export function BusinessSectionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'denominazione': !exists(json, 'denominazione') ? undefined : StringFieldFromJSON(json['denominazione']),
        'corripsondenza': !exists(json, 'corripsondenza') ? undefined : StringFieldFromJSON(json['corripsondenza']),
        'sedeLegale': !exists(json, 'sedeLegale') ? undefined : StringFieldFromJSON(json['sedeLegale']),
        'sedeLegaleIndirizzoConCivico': !exists(json, 'sedeLegaleIndirizzoConCivico') ? undefined : StringFieldFromJSON(json['sedeLegaleIndirizzoConCivico']),
        'sedeLegaleCivico': !exists(json, 'sedeLegaleCivico') ? undefined : StringFieldFromJSON(json['sedeLegaleCivico']),
        'sedeLegaleCap': !exists(json, 'sedeLegaleCap') ? undefined : StringFieldFromJSON(json['sedeLegaleCap']),
        'sedeLegaleComune': !exists(json, 'sedeLegaleComune') ? undefined : StringFieldFromJSON(json['sedeLegaleComune']),
        'sedeLegaleProvincia': !exists(json, 'sedeLegaleProvincia') ? undefined : StringFieldFromJSON(json['sedeLegaleProvincia']),
        'sedeLegaleNazione': !exists(json, 'sedeLegaleNazione') ? undefined : StringFieldFromJSON(json['sedeLegaleNazione']),
        'telefono': !exists(json, 'telefono') ? undefined : StringFieldFromJSON(json['telefono']),
        'telefonoPrefix': !exists(json, 'telefonoPrefix') ? undefined : StringFieldFromJSON(json['telefonoPrefix']),
        'telefonoSuffix': !exists(json, 'telefonoSuffix') ? undefined : StringFieldFromJSON(json['telefonoSuffix']),
        'cellulare': !exists(json, 'cellulare') ? undefined : StringFieldFromJSON(json['cellulare']),
        'email': !exists(json, 'email') ? undefined : StringFieldFromJSON(json['email']),
        'pec': !exists(json, 'pec') ? undefined : StringFieldFromJSON(json['pec']),
        'partitaIva': !exists(json, 'partitaIva') ? undefined : StringFieldFromJSON(json['partitaIva']),
        'codiceFiscale': !exists(json, 'codiceFiscale') ? undefined : StringFieldFromJSON(json['codiceFiscale']),
        'dataInizioAttivita': !exists(json, 'dataInizioAttivita') ? undefined : StringFieldFromJSON(json['dataInizioAttivita']),
        'rea': !exists(json, 'rea') ? undefined : StringFieldFromJSON(json['rea']),
        'cameraCommercio': !exists(json, 'cameraCommercio') ? undefined : StringFieldFromJSON(json['cameraCommercio']),
        'ateco': !exists(json, 'ateco') ? undefined : StringFieldFromJSON(json['ateco']),
        'utile': !exists(json, 'utile') ? undefined : StringFieldFromJSON(json['utile']),
        'residenzaFiscale': !exists(json, 'residenzaFiscale') ? undefined : StringFieldFromJSON(json['residenzaFiscale']),
        'attivita': !exists(json, 'attivita') ? undefined : StringFieldFromJSON(json['attivita']),
        'sdi': !exists(json, 'sdi') ? undefined : StringFieldFromJSON(json['sdi']),
        'tipoAttivitaImprenditoriale': !exists(json, 'tipoAttivitaImprenditoriale') ? undefined : RadioboxFieldFromJSON(json['tipoAttivitaImprenditoriale']),
        'tipoAttivitaImprenditorialeDesc': !exists(json, 'tipoAttivitaImprenditorialeDesc') ? undefined : StringFieldFromJSON(json['tipoAttivitaImprenditorialeDesc']),
        'tipoAttivitaLiberaProfInsc': !exists(json, 'tipoAttivitaLiberaProfInsc') ? undefined : RadioboxFieldFromJSON(json['tipoAttivitaLiberaProfInsc']),
        'tipoAttivitaLiberaProfInscDesc': !exists(json, 'tipoAttivitaLiberaProfInscDesc') ? undefined : StringFieldFromJSON(json['tipoAttivitaLiberaProfInscDesc']),
        'tipoAttivitaLiberaProfNoInsc': !exists(json, 'tipoAttivitaLiberaProfNoInsc') ? undefined : RadioboxFieldFromJSON(json['tipoAttivitaLiberaProfNoInsc']),
        'tipoAttivitaLiberaProfNoInscDesc': !exists(json, 'tipoAttivitaLiberaProfNoInscDesc') ? undefined : RadioboxFieldFromJSON(json['tipoAttivitaLiberaProfNoInscDesc']),
        'tipoAttivitaNoProfit': !exists(json, 'tipoAttivitaNoProfit') ? undefined : RadioboxFieldFromJSON(json['tipoAttivitaNoProfit']),
        'tipoAttivitaNoProfitDesc': !exists(json, 'tipoAttivitaNoProfitDesc') ? undefined : StringFieldFromJSON(json['tipoAttivitaNoProfitDesc']),
        'tipoAttivitaAtro': !exists(json, 'tipoAttivitaAtro') ? undefined : RadioboxFieldFromJSON(json['tipoAttivitaAtro']),
        'tipoAttivitaAltroDesc': !exists(json, 'tipoAttivitaAltroDesc') ? undefined : StringFieldFromJSON(json['tipoAttivitaAltroDesc']),
        'numeroDipendenti': !exists(json, 'numeroDipendenti') ? undefined : StringFieldFromJSON(json['numeroDipendenti']),
        'hasFondiPubbliciTrue': !exists(json, 'hasFondiPubbliciTrue') ? undefined : RadioboxFieldFromJSON(json['hasFondiPubbliciTrue']),
        'hasFondiPubbliciFalse': !exists(json, 'hasFondiPubbliciFalse') ? undefined : RadioboxFieldFromJSON(json['hasFondiPubbliciFalse']),
        'tipoFondiPubblici': !exists(json, 'tipoFondiPubblici') ? undefined : StringFieldFromJSON(json['tipoFondiPubblici']),
        'settorAgricoltura': !exists(json, 'settorAgricoltura') ? undefined : CheckboxFieldFromJSON(json['settorAgricoltura']),
        'settoreCredito': !exists(json, 'settoreCredito') ? undefined : CheckboxFieldFromJSON(json['settoreCredito']),
        'settoreCommercio': !exists(json, 'settoreCommercio') ? undefined : CheckboxFieldFromJSON(json['settoreCommercio']),
        'settoreCaseGico': !exists(json, 'settoreCaseGico') ? undefined : CheckboxFieldFromJSON(json['settoreCaseGico']),
        'settoreNoProfit': !exists(json, 'settoreNoProfit') ? undefined : CheckboxFieldFromJSON(json['settoreNoProfit']),
        'settoreNoProfitDesc': !exists(json, 'settoreNoProfitDesc') ? undefined : StringFieldFromJSON(json['settoreNoProfitDesc']),
        'settoreArtigianato': !exists(json, 'settoreArtigianato') ? undefined : CheckboxFieldFromJSON(json['settoreArtigianato']),
        'settorePA': !exists(json, 'settorePA') ? undefined : CheckboxFieldFromJSON(json['settorePA']),
        'settoreEdilizia': !exists(json, 'settoreEdilizia') ? undefined : CheckboxFieldFromJSON(json['settoreEdilizia']),
        'settoreIndustria': !exists(json, 'settoreIndustria') ? undefined : CheckboxFieldFromJSON(json['settoreIndustria']),
        'settoreMoneyTrans': !exists(json, 'settoreMoneyTrans') ? undefined : CheckboxFieldFromJSON(json['settoreMoneyTrans']),
        'settoreTurismo': !exists(json, 'settoreTurismo') ? undefined : CheckboxFieldFromJSON(json['settoreTurismo']),
        'settoreServizi': !exists(json, 'settoreServizi') ? undefined : CheckboxFieldFromJSON(json['settoreServizi']),
        'settoreComproOro': !exists(json, 'settoreComproOro') ? undefined : CheckboxFieldFromJSON(json['settoreComproOro']),
        'settoreAltro': !exists(json, 'settoreAltro') ? undefined : StringFieldFromJSON(json['settoreAltro']),
        'areaGeograficaItalia': !exists(json, 'areaGeograficaItalia') ? undefined : CheckboxFieldFromJSON(json['areaGeograficaItalia']),
        'areaGeograficaUE': !exists(json, 'areaGeograficaUE') ? undefined : CheckboxFieldFromJSON(json['areaGeograficaUE']),
        'areaGeograficaExtraUE': !exists(json, 'areaGeograficaExtraUE') ? undefined : CheckboxFieldFromJSON(json['areaGeograficaExtraUE']),
        'volumeAffari1': !exists(json, 'volumeAffari1') ? undefined : RadioboxFieldFromJSON(json['volumeAffari1']),
        'volumeAffari2': !exists(json, 'volumeAffari2') ? undefined : RadioboxFieldFromJSON(json['volumeAffari2']),
        'volumeAffari3': !exists(json, 'volumeAffari3') ? undefined : RadioboxFieldFromJSON(json['volumeAffari3']),
        'iscrizioneCamerale': !exists(json, 'iscrizioneCamerale') ? undefined : StringFieldFromJSON(json['iscrizioneCamerale']),
        'naturaGiuridica': !exists(json, 'naturaGiuridica') ? undefined : StringFieldFromJSON(json['naturaGiuridica']),
        'sedeOperativaList': !exists(json, 'sedeOperativaList') ? undefined : (json['sedeOperativaList'].map(SedeOperativaFromJSON)),
    };
}
export function BusinessSectionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'denominazione': StringFieldToJSON(value.denominazione),
        'corripsondenza': StringFieldToJSON(value.corripsondenza),
        'sedeLegale': StringFieldToJSON(value.sedeLegale),
        'sedeLegaleIndirizzoConCivico': StringFieldToJSON(value.sedeLegaleIndirizzoConCivico),
        'sedeLegaleCivico': StringFieldToJSON(value.sedeLegaleCivico),
        'sedeLegaleCap': StringFieldToJSON(value.sedeLegaleCap),
        'sedeLegaleComune': StringFieldToJSON(value.sedeLegaleComune),
        'sedeLegaleProvincia': StringFieldToJSON(value.sedeLegaleProvincia),
        'sedeLegaleNazione': StringFieldToJSON(value.sedeLegaleNazione),
        'telefono': StringFieldToJSON(value.telefono),
        'telefonoPrefix': StringFieldToJSON(value.telefonoPrefix),
        'telefonoSuffix': StringFieldToJSON(value.telefonoSuffix),
        'cellulare': StringFieldToJSON(value.cellulare),
        'email': StringFieldToJSON(value.email),
        'pec': StringFieldToJSON(value.pec),
        'partitaIva': StringFieldToJSON(value.partitaIva),
        'codiceFiscale': StringFieldToJSON(value.codiceFiscale),
        'dataInizioAttivita': StringFieldToJSON(value.dataInizioAttivita),
        'rea': StringFieldToJSON(value.rea),
        'cameraCommercio': StringFieldToJSON(value.cameraCommercio),
        'ateco': StringFieldToJSON(value.ateco),
        'utile': StringFieldToJSON(value.utile),
        'residenzaFiscale': StringFieldToJSON(value.residenzaFiscale),
        'attivita': StringFieldToJSON(value.attivita),
        'sdi': StringFieldToJSON(value.sdi),
        'tipoAttivitaImprenditoriale': RadioboxFieldToJSON(value.tipoAttivitaImprenditoriale),
        'tipoAttivitaImprenditorialeDesc': StringFieldToJSON(value.tipoAttivitaImprenditorialeDesc),
        'tipoAttivitaLiberaProfInsc': RadioboxFieldToJSON(value.tipoAttivitaLiberaProfInsc),
        'tipoAttivitaLiberaProfInscDesc': StringFieldToJSON(value.tipoAttivitaLiberaProfInscDesc),
        'tipoAttivitaLiberaProfNoInsc': RadioboxFieldToJSON(value.tipoAttivitaLiberaProfNoInsc),
        'tipoAttivitaLiberaProfNoInscDesc': RadioboxFieldToJSON(value.tipoAttivitaLiberaProfNoInscDesc),
        'tipoAttivitaNoProfit': RadioboxFieldToJSON(value.tipoAttivitaNoProfit),
        'tipoAttivitaNoProfitDesc': StringFieldToJSON(value.tipoAttivitaNoProfitDesc),
        'tipoAttivitaAtro': RadioboxFieldToJSON(value.tipoAttivitaAtro),
        'tipoAttivitaAltroDesc': StringFieldToJSON(value.tipoAttivitaAltroDesc),
        'numeroDipendenti': StringFieldToJSON(value.numeroDipendenti),
        'hasFondiPubbliciTrue': RadioboxFieldToJSON(value.hasFondiPubbliciTrue),
        'hasFondiPubbliciFalse': RadioboxFieldToJSON(value.hasFondiPubbliciFalse),
        'tipoFondiPubblici': StringFieldToJSON(value.tipoFondiPubblici),
        'settorAgricoltura': CheckboxFieldToJSON(value.settorAgricoltura),
        'settoreCredito': CheckboxFieldToJSON(value.settoreCredito),
        'settoreCommercio': CheckboxFieldToJSON(value.settoreCommercio),
        'settoreCaseGico': CheckboxFieldToJSON(value.settoreCaseGico),
        'settoreNoProfit': CheckboxFieldToJSON(value.settoreNoProfit),
        'settoreNoProfitDesc': StringFieldToJSON(value.settoreNoProfitDesc),
        'settoreArtigianato': CheckboxFieldToJSON(value.settoreArtigianato),
        'settorePA': CheckboxFieldToJSON(value.settorePA),
        'settoreEdilizia': CheckboxFieldToJSON(value.settoreEdilizia),
        'settoreIndustria': CheckboxFieldToJSON(value.settoreIndustria),
        'settoreMoneyTrans': CheckboxFieldToJSON(value.settoreMoneyTrans),
        'settoreTurismo': CheckboxFieldToJSON(value.settoreTurismo),
        'settoreServizi': CheckboxFieldToJSON(value.settoreServizi),
        'settoreComproOro': CheckboxFieldToJSON(value.settoreComproOro),
        'settoreAltro': StringFieldToJSON(value.settoreAltro),
        'areaGeograficaItalia': CheckboxFieldToJSON(value.areaGeograficaItalia),
        'areaGeograficaUE': CheckboxFieldToJSON(value.areaGeograficaUE),
        'areaGeograficaExtraUE': CheckboxFieldToJSON(value.areaGeograficaExtraUE),
        'volumeAffari1': RadioboxFieldToJSON(value.volumeAffari1),
        'volumeAffari2': RadioboxFieldToJSON(value.volumeAffari2),
        'volumeAffari3': RadioboxFieldToJSON(value.volumeAffari3),
        'iscrizioneCamerale': StringFieldToJSON(value.iscrizioneCamerale),
        'naturaGiuridica': StringFieldToJSON(value.naturaGiuridica),
        'sedeOperativaList': value.sedeOperativaList === undefined ? undefined : (value.sedeOperativaList.map(SedeOperativaToJSON)),
    };
}
